import { render, staticRenderFns } from "./User-Added.vue?vue&type=template&id=5e6d9020&"
import script from "./User-Added.vue?vue&type=script&lang=js&"
export * from "./User-Added.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports